import { connect } from 'react-redux';

import ImageMapUploader from '../components/ImageMapUploader';

import { selectUploaderImageMaps } from '../services/selectors';

export default connect(state => ({
    imageMaps: selectUploaderImageMaps(state),
}))(ImageMapUploader);
